const wrapper = "_35sw138jjbp";
const whitespace = "_35swq2tjlr";
const linebreak = "_35sl1lrgf94";
const container = "_35scv5lhw2";

export { container, linebreak, whitespace, wrapper };
import "./_task.mark-words.style.linaria.module.css";
//# sourceMappingURL=_task.mark-words.style.js.map
